import React from 'react';
import { Badge } from '../ui/badge';

const statusConfig = {
  active: { label: 'Active', className: 'bg-green-500/20 text-green-600 border-green-500/30' },
  paused: { label: 'Paused', className: 'bg-yellow-500/20 text-yellow-600 border-yellow-500/30' },
  offline: { label: 'Offline', className: 'bg-red-500/20 text-red-600 border-red-500/30' },
  training: { label: 'In Training', className: 'bg-blue-500/20 text-blue-600 border-blue-500/30' },
  error: { label: 'Error', className: 'bg-red-500/20 text-red-600 border-red-500/30' }
};

export const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.offline;
  return <Badge className={config.className}>{config.label}</Badge>;
};

const priorityConfig = {
  urgent: { label: 'Urgent', className: 'bg-red-500/20 text-red-600' },
  high: { label: 'High', className: 'bg-orange-500/20 text-orange-600' },
  normal: { label: 'Normal', className: 'bg-blue-500/20 text-blue-600' },
  low: { label: 'Low', className: 'bg-gray-500/20 text-gray-600' }
};

export const PriorityBadge = ({ priority }) => {
  const config = priorityConfig[priority] || priorityConfig.normal;
  return <Badge className={config.className}>{config.label}</Badge>;
};

export default StatusBadge;